module.exports = __webpack_public_path__ + "img/reorder_black_24dp.24cf8bd5.svg";